var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"inputs"},[_vm._v(" Inputs: "+_vm._s(this.inputText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }